import React, { useEffect, useState } from "react";
import { saveUserType_Title } from "../../services/v2/signupService";
import { getLocalStorage, setLocalStorage } from "../../helpers/common";
import { USER_INFO_KEY } from "../../constants/common";
import { convertToNumber } from "../../helpers/validations";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";
import { getUserId } from "../../helpers/v2/common";
import { fetchUserDetails } from "../../actions/userprofile";
import { useDispatch } from "react-redux";
import BasicPlanModal from "../../components/PlanUpgrade/BasicPlanModal";
import PremiumPlanModal from "../../components/PlanUpgrade/PremiumPlanModal";

const UserTypeCard = ({
  icon,
  userTypeId,
  title,
  heading,
  description,
  planSelection,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userDetails = getLocalStorage(USER_INFO_KEY);
  const [reload, setReload] = useState(0);
  const [showBasicPlanModal, setBasicPlanModal] = useState(false);
  const BasicPlanModalClose = () => setBasicPlanModal(false);
  const BasicPlanModalShow = () => setBasicPlanModal(true);
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);
  const PremiumPlanModalClose = () => setPremiumPlanModal(false);
  const PremiumPlanModalShow = () => setPremiumPlanModal(true);

  // To update the reload state value
  const updateReloadParam = () => {
    setReload(reload + 1);
  };

  useEffect(() => {
    const userId = getUserId();
    if (userId) {
      dispatch(fetchUserDetails());
    }
  }, [reload]);

  const saveUserTypeAndTitle = async (reqPayload) => {
    try {
      const response = await saveUserType_Title(reqPayload);
      if (!response || response.errorCode !== 0) {
        throw new Error("Failed to save user type and title");
      }
      return response;
    } catch (error) {
      throw error;
    }
  };

  const handleCardClick = async () => {
    try {
      const reqPayload = { userTypeId, title } ;
      const res = await saveUserTypeAndTitle(reqPayload);
      userDetails.userInfo.userType = convertToNumber(userTypeId);
      userDetails.userInfo.userTitle = planSelection;

      if (title) {
        userDetails.userInfo.agentTitle = convertToNumber(title);
      } else {
        // Remove agentTitle if it exists and no title is provided
        if (userDetails.userInfo.hasOwnProperty("agentTitle")) {
          delete userDetails.userInfo.agentTitle;
        }
      }

      setLocalStorage(USER_INFO_KEY, userDetails);
      navigate(pageURLs.home);
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <div className="col-md-3">
        <div
          className="create-first-contentbox user-type-contentbox mb-24"
          onClick={handleCardClick}
        >
          <div className=" mb-4">
            <img src={icon} alt={`${heading} Icon`} />
          </div>
          <h6 className="mb-2">{heading}</h6>
          <p>{description}</p>
        </div>
      </div>

      <PremiumPlanModal
        userDetails={userDetails}
        updateReloadParam={updateReloadParam}
        show={showPremiumPlanModal}
        onHide={PremiumPlanModalClose}
        showPlanModal={PremiumPlanModalShow}
        showCloseButton={true}
      />

      <BasicPlanModal
        userDetails={userDetails}
        show={showBasicPlanModal}
        updateReloadParam={updateReloadParam}
        onHide={BasicPlanModalClose}
        showPlanModal={BasicPlanModalShow}
        showCloseButton={true}
      />
    </>
  );
};

export default UserTypeCard;
